// Local storage key for storing overridden feature flags
export const FEATURES_KEY = 'appcues:devtools:features';
